<template>
  <div class="page-overlay">
    <div class="page-overlay-container" :class="{ active: active, open: isOpen, animate: !dragging, 'stop-scroll': dragging }">
      <div class="drag-arrow black" :class="{active: dragging}"><span class="line line-1"></span><span class="line line-2"></span></div>

      <div class="page-overlay-content">
        <!-- PARTNER -->
        <template v-if="!item.length">
          <div class="artist-profile">
            <div class="artist-profile-content partner">
              <div class="artist-info">
                <span v-if="item.type === 'businesspartners'" class="eyebrow">Business Partner</span>
                <span v-if="item.type === 'communitypartners'" class="eyebrow">Community Partner</span>
                <span class="artist-title"><span v-html="item.business_name"></span></span>
                <h3 class="artist-address user-selectable"><span v-if="item.tour_address">{{ item.tour_address }}</span></h3>
              </div>
              <div v-if="item.featured_image && item.featured_image.url" class="artist-icon" :style="'background-image:url(' + encodeURI(item.featured_image.url) + ')'"></div>
            </div>
            <div class="artist-actions">
              <button class="btn" @click="goToPartner(item.id)">View Profile</button>
              <button class="btn" @click="getDirectionsPartner(item)">Get Directions</button>
            </div>
          </div>
        </template>

        <!-- ARTIST -->
        <template v-else>
          <div class="artist-profile" v-for="artist in item" :key="artist.id">
            <div class="artist-profile-content test">
              <div class="artist-info">
                <span class="artist-title" :style="'font-size:' + titleFontSize(artist) + 'px;'"><template v-if="artist.tour_number">{{artist.tour_number}}. </template><span v-html="artist.name"></span></span>
                <p class="medium"><span>{{ artist.medium }}</span></p>
                <h3 class="artist-address user-selectable">{{ artist.tour_address }} {{ artist.tour_address_2 }}</h3>
              </div>
              <div v-if="artist.artwork[0]" class="artist-icon" :style="'background-image:url(' + encodeURI(artist.artwork[0].images[0].image.url) + ')'"></div>
              <div v-else-if="artist.headshot" class="artist-icon" :style="'background-image:url(' + encodeURI(artist.headshot.url) + ')'"></div>
            </div>
            <div class="artist-actions">
              <button class="btn" @click="goToArtist(artist.id)">View Profile</button>
              <button class="btn" @click="getDirections(artist)">Get Directions</button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="page-overlay-backdrop" :class="{ open: isOpen, closing: isClosing }" @click="close"></div>
  </div>
</template>

<script>
import PageOverlay from "../../mixins/PageOverlay";

export default {
  props: ['item'],
  mixins: [PageOverlay],
  methods: {
    getDirections(artist) {
      if (!this.$root.currentPosition.length) {
        this.$root.openBrowser(`http://maps.google.com/?q=${artist.coordinates}`);
      } else {
        this.$parent.getDirections([artist]);
        this.close();
      }
    },
    goToArtist(id) {
      this.$router.push("/participants/" + id);
    },
    goToPartner(id) {
      this.$router.push(`/partners/${id}`);
    },
    getDirectionsPartner(partner) {
      this.$root.openBrowser(`http://maps.google.com/?q=${partner.coordinates}`);
    },
    titleFontSize(artist) {
      let fontSize = 25;
      if (artist.name.length > 8) fontSize = 22;
      return fontSize;
    },
  },
};
</script>

<style scoped lang="less">
@import '../../css/variables';

.artist-profile {
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #d0d2d2;
  &:last-child {
    border-bottom: 0;
  }
  &:only-child {
    padding: 0;
  }
}

.artist-profile-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .artist-info {
    max-width: calc(~"100% - 99px");
    padding-right: 10px;
    &.sansImage {
      max-width: 100%;
      padding-right: 0;
    }
  }
  .artist-title {
    display: block;
    overflow: hidden;
    font-size: 25px;
    font-weight: bold;
    line-height: 33px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .artist-category,
  .artist-address {
    font-size: 15px;
  }
  .medium {
    margin-bottom: 5px;
    overflow: hidden;
    font-size: 15px;
    line-height: 20px;
    font-style: italic;
    text-transform: capitalize;
  }
  .btn {
    padding: 7px 30px;
  }
  .artist-icon {
    min-width: 82px;
    height: 82px;
    background-size: cover;
    background-position: center;
    background-color: #1e1e1e;
    border-radius: 82px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
  &.partner {
    margin-bottom: 10px;
    .artist-address {
      margin-bottom: 3px;
      font-weight: normal;
      &:last-of-type {
        margin-top: 7px;
      }
    }
  }
}

.eyebrow {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  color: @themeColor3;
}

.artist-actions {
  display: flex;
  justify-content: space-between;
  .btn {
    flex-grow: 1;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Map/Profile.vue